/** Roles allowed to open the human review queue for roleplay sessions (mirror server: `trainingAuth`). */
export function canHumanReviewRoleplay(hasRole: (...r: string[]) => boolean): boolean {
  return hasRole(
    "trainer",
    "marketing",
    "admin",
    "owner",
    "dev",
    "org_admin",
    "org_owner",
    "platform_owner",
    "platform_trainer",
    "platform_admin",
    "platform_dev"
  );
}

/** Trainer+ (not sales-only): edit org roleplay scenarios, org flags, and see platform example in lists. */
export function canEditTrainingRoleplayScenarios(hasRole: (...r: string[]) => boolean): boolean {
  return canHumanReviewRoleplay(hasRole);
}
